/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalDocumentInstancesQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalDocumentInstancesInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalDocumentInstancesQuery = {
  __typename?: 'Query';
  internalDocumentInstances: {
    __typename: 'InternalRegulationDocumentInstancesConnection';
    edges: Array<{
      __typename: 'InternalRegulationDocumentInstanceEdge';
      cursor: string;
      node: {
        __typename: 'InternalRegulationDocumentInstance';
        id: string;
        name: string;
        level?: number | null;
        citation?: string | null;
        documentUrl?: string | null;
        documentVersion?: string | null;
        createdTimestamp: string;
        regulationDocumentId: string;
        obligationReviewStatus: Types.IInternalRegulationDocumentReviewStatus;
        mappingsReviewStatus: Types.IInternalRegulationDocumentReviewStatus;
        documentDisplayCode?: string | null;
        documentCode?: string | null;
      };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalDocumentInstancesDocument = gql`
  query internalDocumentInstances($input: InternalDocumentInstancesInput, $first: Int, $after: String) {
    internalDocumentInstances(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          name
          level
          citation
          documentUrl
          documentVersion
          createdTimestamp
          regulationDocumentId
          obligationReviewStatus
          mappingsReviewStatus
          documentDisplayCode
          documentCode
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalDocumentInstancesQuery__
 *
 * To run a query within a React component, call `useInternalDocumentInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalDocumentInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalDocumentInstancesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalDocumentInstancesQuery(
  baseOptions?: Apollo.QueryHookOptions<IInternalDocumentInstancesQuery, IInternalDocumentInstancesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalDocumentInstancesQuery, IInternalDocumentInstancesQueryVariables>(
    InternalDocumentInstancesDocument,
    options,
  );
}
export function useInternalDocumentInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IInternalDocumentInstancesQuery, IInternalDocumentInstancesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalDocumentInstancesQuery, IInternalDocumentInstancesQueryVariables>(
    InternalDocumentInstancesDocument,
    options,
  );
}
// @ts-ignore
export function useInternalDocumentInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalDocumentInstancesQuery,
    IInternalDocumentInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IInternalDocumentInstancesQuery, IInternalDocumentInstancesQueryVariables>;
export function useInternalDocumentInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalDocumentInstancesQuery, IInternalDocumentInstancesQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalDocumentInstancesQuery | undefined, IInternalDocumentInstancesQueryVariables>;
export function useInternalDocumentInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalDocumentInstancesQuery, IInternalDocumentInstancesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IInternalDocumentInstancesQuery, IInternalDocumentInstancesQueryVariables>(
    InternalDocumentInstancesDocument,
    options,
  );
}
export type InternalDocumentInstancesQueryHookResult = ReturnType<typeof useInternalDocumentInstancesQuery>;
export type InternalDocumentInstancesLazyQueryHookResult = ReturnType<typeof useInternalDocumentInstancesLazyQuery>;
export type InternalDocumentInstancesSuspenseQueryHookResult = ReturnType<
  typeof useInternalDocumentInstancesSuspenseQuery
>;
export type InternalDocumentInstancesQueryResult = Apollo.QueryResult<
  IInternalDocumentInstancesQuery,
  IInternalDocumentInstancesQueryVariables
>;
